export const topDividerSx = (theme) => ({
  borderColor: theme.palette.accent.secondary,
  marginTop: '16px',
});

export const checkboxContainerSx = {
  display: 'flex',
  justifyContent: 'center',
  alignContent: 'center',
};

export const formControlLabelSx = (theme) => ({
  typography: {
    color: theme.palette.secondary.main,
    fontSize: '12px !important',
    margin: 0,
  },
});

export const checkboxSx = (theme) => ({
  color: theme.palette.secondary.main,
});

export const hyperlinkSx = (theme) => ({
  fontSize: '12px !important',
  color: theme.palette.tertiary.main,
  textDecoration: 'none',
  cursor: 'pointer',
  '&:hover': {
    color: theme.palette.quaternary.main,
  },
});

export const bottomDividerSx = (theme) => ({
  borderColor: theme.palette.accent.secondary,
  marginBottom: '8px',
});
